import { render, staticRenderFns } from "./TopFaqPopup.vue?vue&type=template&id=17a91c3e&scoped=true"
import script from "./TopFaqPopup.vue?vue&type=script&lang=js"
export * from "./TopFaqPopup.vue?vue&type=script&lang=js"
import style0 from "./TopFaqPopup.vue?vue&type=style&index=0&id=17a91c3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a91c3e",
  null
  
)

export default component.exports